import { createRoot } from 'react-dom/client';
import App from '@/components/App';
import { enableMocking } from '@/mocks';
import '@/i18n';

import '@fontsource/geologica/greek-300.css';
import '@fontsource/geologica/greek-400.css';
import '@fontsource/geologica/greek-500.css';
import '@fontsource/geologica/greek-600.css';
import '@fontsource/geologica/latin-300.css';
import '@fontsource/geologica/latin-400.css';
import '@fontsource/geologica/latin-500.css';
import '@fontsource/geologica/latin-600.css';

import '@fontsource/inter/greek-300.css';
import '@fontsource/inter/greek-400.css';
import '@fontsource/inter/greek-500.css';
import '@fontsource/inter/greek-600.css';
import '@fontsource/inter/latin-300.css';
import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-500.css';
import '@fontsource/inter/latin-600.css';

enableMocking().then(() => {
  createRoot(document.getElementById('root') as HTMLElement).render(<App />);
});
